exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.push([module.id, "@import url(https://fonts.googleapis.com/css?family=Jaldi:400,700);", ""]);

// module
exports.push([module.id, "\n.menus-wrap{margin:auto\n}\nul{list-style:none;padding:0;margin:0\n}\n.menus{display:flex;flex-wrap:wrap\n}\nbutton{cursor:pointer;transition:background-color .3s ease;background-color:#34bd34;border:0;color:white;font-size:0.7rem;padding:7px 10px;text-transform:uppercase\n}\nbutton:hover{background-color:#319831\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-243467b2","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/MenusList.vue
// module id = 392
// module chunks = 0